import React from 'react';
import { Outlet } from 'react-router-dom'; // Importar o Outlet
import Header from './Header';
import Footer from './Footer';

const Layout = ({ hideFooter = false }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow mt-16">
        <Outlet /> {/* Usar Outlet para renderizar as rotas aninhadas */}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
